export function NsofarLogo({ size = 'md', className = '', dark = false }) {
  const sizes = {
    xs: { name: 'text-2xl' },
    sm: { name: 'text-3xl' },
    md: { name: 'text-4xl' },
    lg: { name: 'text-6xl' },
    xl: { name: 'text-8xl' },
  };

  const s = sizes[size] || sizes.md;
  // `dark` prop forces white (used on the LandingPage's dark CTA
  // banner). Otherwise the wordmark colour comes from the token,
  // which flips automatically with the html.dark theme.
  const nameColor = dark ? '#FFFFFF' : 'var(--logo-wordmark)';

  return (
    <div className={className} data-testid="nsofar-logo">
      <span className={`${s.name} font-bold tracking-tight`}
        style={{ fontFamily: 'Outfit, sans-serif', color: nameColor, lineHeight: 1.1 }}>
        nsofar
      </span>
    </div>
  );
}
